import React from "react";
import {
    Grid,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
    CircularProgress,
    Paper,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import Colors from "assets/Style/Colors";
import { makeStyles } from "@mui/styles";
import { FontFamily } from "assets";
import { PrimaryButton } from "components/Buttons";
import { useState, Fragment } from "react";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { SuccessToaster } from "components/Toaster";
import { useNavigate } from "react-router-dom";

import { Upload } from "@mui/icons-material";

import UploadFile from "components/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "context/UseContext";
import { startVccBotAgent } from "utils/lambda";

import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';


const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        padding: "15px",
        textAlign: "center",
        whiteSpace: "nowrap",
        background: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "center",
        textWrap: "nowrap",

        padding: "5px !important",
        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },

        '.truncate-text': {
            display: 'inline-block',
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
}));


const useStyles = makeStyles({
    loaderWrap: {
        display: "flex",
        height: 100,
        "& svg": {
            width: "40px !important",
            height: "40px !important",
        },
    },
});

function UploadVcc() {
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const navigate = useNavigate();
    const [isSearching, setIsSearching] = useState(false);

    const { user } = useAuth();

    const {
        register,
        handleSubmit,
        getValues: getValues1,
        setValue,
        formState: { errors },
        watch,
    } = useForm();

    const tableHead = [
        "Sr.No",
        "File Name",
        "Vcc Number",
        "VIN",
    ];


    const [loader, setLoader] = useState(false);

    const [declarationUploadDialog, setDeclarationUploadDialog] = useState(false);
    const [declarationUploadViewDialog, setDeclarationUploadViewDialog] = useState(false);

    const [pdfData, setPdfData] = useState([]);

    const [uploadedFileName, setUploadedFileName] = useState("");
    const [file, setFile] = useState(null);
    const [progress2, setProgress2] = useState(0);
    const [uploadedSize2, setUploadedSize2] = useState(0);
    const [documentDetail2, setDocumentDetail2] = useState([]);
    const [documentLink2, setDocumentLink2] = useState('')
    const allowDeclarationFilesType = ['application/pdf']
    const [selectedFiles, setSelectedFiles] = useState([]);
     const [uploadedFileNames, setUploadedFileNames] = useState([]);
    console.log(selectedFiles, 'file')

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to an array
        setSelectedFiles(files); // Save the selected files in the state
        SuccessToaster("files uploaded")
    };

async function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      resolve({
        name: file.name,
        mimetype: file.type || "application/pdf",
        base64: base64String, // ✅ include proper key
      });
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}


    const handleUpload = async () => {
        if (selectedFiles.length === 0) {
            console.log("No files selected");
            return;
        }

        try {
              const fileDataArray = await Promise.all(
                selectedFiles.map((file) => convertFileToBase64(file)) 
              );

            // const fileDataArray = selectedFiles.map((f) => ({
            //     name: f.name,
            //     mimetype: f.mimetype,
            //     base64: f.buffer.toString("base64"), // 👈 convert binary → base64
            // }));

            const payload = {
                table: "vcc",
                files: fileDataArray,
            };

            console.log(payload, 'payload')

            await startVccBotAgent(payload);

            console.log("Files uploaded and processed successfully!");
            setDeclarationUploadDialog(false)
        } catch (error) {
            console.error("Error uploading files:", error);
        }
    };


    

    // invokeLambda();


    // const convertFileToBase64 = (file) => {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => resolve(reader.result.split(",")[1]);
    //         reader.onerror = reject;
    //         reader.readAsDataURL(file);
    //     });
    // };


    const extractText = (text) => {
        const t = text.replace(/\s+/g, ' ').trim();

        const vccNumber = t.match(/(\d{8})(?=\s*\d{2}\/\d{2}\/\d{4}|$)/)[0] || '';

        const vinNumber = (t.match(/(?<=TR\sLLC\s)([A-HJ-NPR-Z0-9]{17})/) || [])[0] || '';


        return {

            vccNumber,
            vinNumber,
        };
    };


    const extractTextWithPosition = (content) => {
        const sortedItems = content.items.sort((a, b) => {
            if (a.transform[5] === b.transform[5]) {
                return a.transform[4] - b.transform[4];
            }
            return a.transform[5] - b.transform[5];
        });

        let pageText = "";
        sortedItems.forEach(item => {
            pageText += item.str + " ";
        });

        return pageText.trim();
    };


    const extractPdfData = async (arrayBuffer, fileName) => {
        try {
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            const numPages = pdf.numPages;

            let extractedData = [];


            for (let pageNum = 1; pageNum <= numPages; pageNum++) {
                const page = await pdf.getPage(pageNum);
                const content = await page.getTextContent();
                const pageText = extractTextWithPosition(content);

                console.log(pageText, 'pageText')

                const pageData = extractText(pageText);

                pageData.fileName = fileName;


                const isDuplicate = extractedData.some((data) =>
                    data.vccNumber === pageData.decNo ||
                    data.vinNumber === pageData.vinNumber
                );

                if (!isDuplicate) {
                    extractedData.push(pageData);
                }
            }
            return extractedData;
        } catch (error) {
            console.error('Error extracting PDF data:', error);
            return [];
        }
    };


    const handleFileUpload = async (e) => {
        // const file = e.target.files[0]; 
        const files = e.target.files;

        console.log(files, 'files')

        if (files.length === 0) return;

        // if (!file) return; 

        let allExtractedData = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const arrayBuffer = await file.arrayBuffer();

            console.log(file, 'file');
            console.log(arrayBuffer, 'arraybufer')

            const extractedData = await extractPdfData(arrayBuffer, file.name);

            allExtractedData = [...allExtractedData, ...extractedData];
        }
        // const arrayBuffer = await file.arrayBuffer();

        // const extractedData = await extractPdfData(arrayBuffer, file.name);

        // setPdfData(extractedData);
        setPdfData(allExtractedData);
        setDeclarationUploadDialog(false);
        // setDeclarationUploadViewDialog(true);
    };
    const handleCloseUploadDialog = () => {
        setDeclarationUploadDialog(false);
        setFile(null);
        setUploadedFileName("");
    };

    const handleCloseUploadViewDialog = () => {
        setDeclarationUploadViewDialog(false);

    };

    console.log(pdfData, 'pdfdata')


    return (
        <>


            {/* <Dialog open={declarationUploadViewDialog} onClose={handleCloseUploadViewDialog}>
                <DialogTitle>Uploaded Files</DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>File</TableCell>
                                <TableCell>DEC NO</TableCell>
                                <TableCell>DEC DATE</TableCell>
                                <TableCell>Container Nos</TableCell>
                                <TableCell>Last Three Digit Of VIN</TableCell>
                                <TableCell>Total Duty AED</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pdfData.map((data, index) => (
                                <TableRow key={index}>
                                    <TableCell>{data.fileName}</TableCell>
                                    <TableCell>{data.decNo}</TableCell>
                                    <TableCell>{data.decDate}</TableCell>
                                    <TableCell>{data.containerNos.join(', ')}</TableCell>
                                    <TableCell>{data.usedVehicles.join(', ')}</TableCell>
                                    <TableCell>{data.insValues.join(', ')}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog> */}

            <Dialog
                open={declarationUploadDialog}
                onClose={handleCloseUploadDialog}
                PaperProps={{ sx: { p: 2, width: "500px", borderRadius: "14px" } }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span>Upload VCC</span>
                    <IconButton onClick={handleCloseUploadDialog} sx={{ padding: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>


                    <Typography variant="body1" sx={{ mb: 1 }}>
                        Attach File
                    </Typography>
                    <UploadFile
                        custom={true}
                        vendor={true}
                        multiple={true}
                        style={{
                            backgroundColor: "#e7efeb",
                            width: "100%",
                            height: "40px",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "30px",
                            border: "1px dashed #aeb1b0",
                            borderRadius: "10px",
                        }}
                        error={errors?.scanned?.message}
                        register={register("scanned", {
                            onChange: (e) => 
                            handleFileChange(e)
                            // handleFileUpload(e),

                        })}
                    />

                    {uploadedFileName && (
                        <Typography
                            variant="body2"
                            sx={{ marginTop: "10px", color: "#333" }}
                        >
                            <strong>Uploaded Files: </strong>
                            {uploadedFileName}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <PrimaryButton title={"Upload"}
                        onClick={handleUpload}
                        disabled={selectedFiles.length === 0} />
                </DialogActions>
            </Dialog>

            <Box component={"form"}>
                <Box sx={{ width: "100%" }}>
                    <Grid container>
                        <Grid item md={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    my: 3,
                                    ml: 4,
                                    mr: 8,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: Colors.charcoalGrey,
                                        fontFamily: FontFamily.NunitoRegular,
                                        textAlign: "left",
                                    }}
                                >
                                    Upload Vcc
                                </Typography>
                                <Box
                                    sx={{
                                        textAlign: "right",
                                        p: 4,
                                        display: "flex",
                                        gap: 2,
                                    }}
                                >
                                    <PrimaryButton
                                        title="Upload Vcc"
                                        type="button"
                                        style={{ backgroundColor: Colors.bluishCyan }}
                                        startIcon={<Upload sx={{ color: Colors.white }} />}
                                        onClick={() => setDeclarationUploadDialog(true)}

                                    />
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Box>

                <Grid
                    container
                    // xs={10}
                    sx={{
                        borderRadius: "5px",
                        m: 4,
                        mt: 0,
                    }}
                ></Grid>

                <Box sx={{ m: 4, mb: 2 }}>
                    {pdfData ? (
                        <Fragment>

                            {/* ========== Table ========== */}
                            <TableContainer
                                component={Paper}
                                sx={{
                                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                    borderRadius: 2,
                                }}
                                className="table-box"
                            >
                                <Table stickyHeader sx={{ minWidth: 500 }}>
                                    <TableHead>
                                        <TableRow>
                                            {tableHead.map((item, index) => (
                                                <Cell className="pdf-table" key={index}>
                                                    {item}
                                                </Cell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!loader ? (
                                            pdfData.length > 0 ? (
                                                <Fragment>
                                                    {pdfData.map((item, index) => {

                                                        return (
                                                            <Row
                                                                key={index}
                                                                sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                                                            >
                                                                <Cell className="pdf-table">
                                                                    {index + 1 ?? "-"}
                                                                </Cell>
                                                                <Cell className="pdf-table">
                                                                    {item?.fileName ?? "-"}
                                                                </Cell>
                                                                <Cell className="pdf-table">
                                                                    {item?.vccNumber ?? "-"}
                                                                </Cell>
                                                                {/* <Cell className="pdf-table">
                                                                    {item?.vccDate ?? "-"}

                                                                </Cell> */}
                                                                <Cell className="pdf-table">
                                                                    {item?.vinNumber}
                                                                </Cell>


                                                            </Row>
                                                        );
                                                    })}
                                                </Fragment>
                                            ) : (
                                                <Row>
                                                    <Cell
                                                        colSpan={tableHead?.length + 1}
                                                        align="center"
                                                        sx={{ fontWeight: 600 }}
                                                    >
                                                        No Data Found
                                                    </Cell>
                                                </Row>
                                            )
                                        ) : (
                                            <Row>
                                                <Cell
                                                    colSpan={tableHead?.length + 2}
                                                    align="center"
                                                    sx={{ fontWeight: 600 }}
                                                >
                                                    <Box className={classes.loaderWrap}>
                                                        <CircularProgress />
                                                    </Box>
                                                </Cell>
                                            </Row>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* <Box
                                sx={{
                                    bottom: '20px',
                                    right: '20px',
                                    textAlign: 'right',
                                    marginTop: "20px",

                                }}
                            >
                                <PrimaryButton
                                    title="Submit"
                                    onClick={() => console.log("Submit button clicked")}
                                    style={{ backgroundColor: Colors.bluishCyan }}
                                />
                            </Box> */}


                        </Fragment>
                    ) : (
                        ""
                    )}
                </Box>
            </Box>
        </>
    );
}
export default UploadVcc;
